// extracted by mini-css-extract-plugin
export default {"wrapper":"HomePage_wrapper_whLKN","title":"HomePage_title_wJ8xo"};